export default __webpack_public_path__ + "static/media/accessories.027ada94.jpg";